import { render, staticRenderFns } from "./EstimatedDate.vue?vue&type=template&id=a9708898&"
import script from "./EstimatedDate.vue?vue&type=script&lang=js&"
export * from "./EstimatedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QChip,QTooltip})
